exports = module.exports = require("../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".summary-border{padding:20px}.summary-statement-container{margin-top:-23px;width:180px;float:left}.summary-statement-container small{color:#7a7a7f;font-size:13px;float:right;position:relative;top:-6px}.summary-number{color:#656565;font-size:24px;float:left;font-weight:600;width:180px;text-align:right}.summary-number small{font-size:18px;color:#656565;top:0;left:3px;position:relative;float:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader?minimize!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28632543","scoped":false,"hasInlineConfig":false}!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/forms/pedido-titulos.vue
// module id = 1523
// module chunks = 0